var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('HeatmapChart',{attrs:{"loading":_vm.heatmapQuery.loading,"resolved":_vm.heatmapQuery.status.isResolved(),"x-axis":_vm.heatmapQuery.xAxis,"y-axis":_vm.heatmapQuery.yAxis,"data":_vm.heatmapQuery.data,"unit":_vm.gridItem.params.unit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }